import { render, staticRenderFns } from "./att-header.vue?vue&type=template&id=f87d96a4&scoped=true&"
import script from "./att-header.vue?vue&type=script&lang=js&"
export * from "./att-header.vue?vue&type=script&lang=js&"
import style0 from "./att-header.vue?vue&type=style&index=0&id=f87d96a4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f87d96a4",
  null
  
)

export default component.exports